module.exports = __webpack_public_path__ + "img/Times-off-leave.457cef05.png";